import {
  PLAN_AGENCY,
  PLAN_FREE,
  PLAN_PRO,
  PLAN_PRO2,
  PLAN_PRO3,
  PLAN_TEAM,
  PLAN_TEAM3SEATS,
  PLAN_TEAMPERSEAT,
  PLAN_TEAMPERSEAT2,
} from '@/constants/userSubscriptionPlans'
import css from './styles.module.css'

export const PlanClasses: Record<string, string> = {
  [PLAN_FREE]: css.free,
  [PLAN_PRO]: css.pro,
  [PLAN_PRO2]: css.pro,
  [PLAN_PRO3]: css.pro,
  [PLAN_TEAM]: css.team,
  [PLAN_TEAMPERSEAT]: css.team,
  [PLAN_TEAM3SEATS]: css.team,
  [PLAN_TEAMPERSEAT2]: css.team,
  [PLAN_AGENCY]: css.team,
}

export const PlanLabel: Record<string, string> = {
  [PLAN_FREE]: 'Free plan',
  [PLAN_PRO]: 'Pro plan',
  [PLAN_PRO2]: 'Pro plan',
  [PLAN_PRO3]: 'Pro plan',
  [PLAN_TEAM]: 'Team plan',
  [PLAN_TEAMPERSEAT]: 'Team plan',
  [PLAN_TEAM3SEATS]: 'Team plan',
  [PLAN_TEAMPERSEAT2]: 'Team plan',
  [PLAN_AGENCY]: 'Team plan',
}
